/**
 * Thin presentational wrapper that maps unwrapped single-order data into the
 * {@link HeaderSingleOrder} prop bag and renders it.
 *
 * Lives between {@link SingleOrderLayout} (which knows the data sources) and
 * {@link HeaderSingleOrder} (which knows how to render the header) so neither
 * has to know about the other's shape.
 *
 * @module SingleOrderHeader
 */
import React from "react";
import {
  AuthOnFile,
  GeneralOrderDetails,
  SingleCoverage,
} from "../../../data-model/medicalPaOrdersModel";
import { Submission } from "../../../hooks/singleMedicalPaOrderDetails/useSubmissionInformation";
import { buildHeaderProps } from "../utils/buildHeaderProps";
import HeaderSingleOrder from "./header/header";

interface SingleOrderHeaderProps {
  order: GeneralOrderDetails | null;
  authOnFile: AuthOnFile | null;
  coverages: SingleCoverage[] | null;
  submission: Submission | null;
  hideButton: boolean | undefined;
  refetchAllData: () => void;
}

const SingleOrderHeader: React.FC<SingleOrderHeaderProps> = ({
  order,
  authOnFile,
  coverages,
  submission,
  hideButton,
  refetchAllData,
}) => {
  const headerProps = buildHeaderProps({
    order,
    authOnFile,
    coverages,
    submission,
    hideButton,
    refetchAllData,
  });
  return <HeaderSingleOrder {...headerProps} />;
};

export default SingleOrderHeader;
